import { checkTerm } from 'commons/api/blacklistService/blacklistService';
import { i18n } from 'commons/translate/i18n';

const { t } = i18n.global;

/**
 * @see blacklistService for available types
 */
export function getBlacklistValidator(type = 'description') {
  return async function (text) {
    const blocklistResult = await checkTerm({ field: type, terms: text });

    if (blocklistResult?.blockedTerms?.length) {
      const blacklistedTerms = blocklistResult?.blockedTerms
        .reduce((terms, blacklist) => {
          return terms.concat(blacklist.foundBlockedTerms);
        }, [])
        .join(', ');
      throw new Error(
        `${t('DESIGNS.VALIDATION.BLACKLIST.TERMS')}: ${blacklistedTerms}`,
      );
    } else {
      return;
    }
  };
}
